import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../../config/api-urls/api-urls';
import { MainService } from '../../../../../provider/main.service';
@Component({
  standalone: false,
  selector: 'app-edit-faq',
  templateUrl: './edit-faq.component.html',
  styleUrls: ['./edit-faq.component.css']
})
export class EditFaqComponent implements OnInit {

  form: FormGroup | any;
  faqList: any;
  userId: any;

  constructor(private router: Router, public mainService: MainService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.form = new FormGroup({
      "question": new FormControl('', Validators.required),
      "answer": new FormControl('', Validators.required),
    });
    this.activatedRoute.params.subscribe((res) => {
      this.userId = res.id;
    })
    this.getFaqList()
  }

  getFaqList() {
    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.viewFaq + `?faqId=${this.userId}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.faqList = res.result;
        this.form.patchValue({
          "question": this.faqList.question,
          "answer": this.faqList.answer
        })
        this.mainService.hideSpinner();
        // this.mainService.successToast(res.responseMessage);
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

  // To edit faq api

  editFaq() {
    const data = {
      question: this.form.value.question,
      answer: this.form.value.answer,
      faqId: this.userId
    }
    this.mainService.showSpinner()
    this.mainService.putApi(ApiUrls.editFaq, data, 1).subscribe((res) => {
      this.mainService.hideSpinner();
      if (res.responseCode == 200) {
        this.mainService.successToast(res.responseMessage);
        this.router.navigate(['faq-mgt'])

      }
      else {
        this.mainService.errorToast(res.responseMessage);

      }
    }, err => {
      this.mainService.errorToast(err.responseMessage);
    })
  }

}
